<template>
	<div :class="vSignatureClass" class="v-signature">
		<div class="v-signature__canvas">
			<vueSignature
				:key="signatureKey"
				ref="signature"
				:defaultUrl="defaultUrl"
				:disabled="!active" :h="height + 'px'" :sig-option="options" :w="width + 'px'"
				@beginStroke="beginStroke"
				@endStroke="endStroke"
			/>
		</div>
		<ul v-if="active" class="v-signature__controls">
			<li>
				<button v-if="clearable" class="v-signature__clear" @click.prevent="clear()">Clear</button>
			</li>
			<li>
				<button v-if="clearable" class="v-signature__undo" @click.prevent="undo()">Undo</button>
			</li>
		</ul>
	</div>
</template>
<script>
import vueSignature from "vue-signature";

export default {
	components: {
		vueSignature,
	},

	data() {
		return {
			width: null,
			height: null,
			mounted: false,
			eventTime: 0,
			strokes: [],
			signatureKey: 0,
		};
	},

	props: {
		fixedWidth: {
			required: false,
			type: String,
		},
		heightRatio: {
			required: false,
			type: Number,
			default() {
				return .4;
			},
		},
		mode: {
			required: false,
			type: String,
			default() {
				return "svg";
			},
		},
		active: {
			required: true,
			type: Boolean,
		},
		clearable: {
			required: false,
			type: Boolean,
			default() {
				return true;
			},
		},
		signature: {
			required: false,
			type: String,
		},
		empty: {
			required: false,
			type: String,
			default() {
				return window.endpoints.assets + "/assets/img/signature.png";
			},
		},
		minStrokeDuration: {
			required: false,
			type: Number,
			default() {
				return .25;
			},
		},
	},

	computed: {
		options() {
			return {};
		},
		vSignatureClass() {
			return {
				"v-signature--active": this.active,
				"v-signature--signed": this.signature,
			};
		},
		mime() {
			return {
				svg: "image/svg+xml",
				jpeg: "image/jpeg",
			}[this.mode] || null;
		},
		defaultUrl() {
			if (this.signature) {
				return "data:image/svg+xml;base64," + this.signature;
			}

			return this.empty;
		},
		strokeDuration() {
			return _.sum(this.strokes);
		},
		strokeDurationPercentage() {
			return Math.min((this.strokeDuration / this.minStrokeDuration) * 100, 100);
		},
		strokeDurationReached() {
			return this.strokeDurationPercentage === 100;
		},
		markMade() {
			return this.strokes.length > 0;
		},
	},

	methods: {
		clear(reset = true) {
			this.eventTime = 0;
			this.strokes = [];
			this.emitChange();
			if (!reset) {
				this.$refs.signature.clear();
				return this.$emit("cleared", true);
			}
			this.reset();
		},
		undo() {
			this.$refs.signature.undo();
			this.strokes.pop();
			this.emitChange();
			if (!this.markMade) {
				this.reset();
			}
		},
		reset() {
			this.signatureKey++;
		},
		getSignature() {
			return {
				mime: this.mime,
				base64: this.$refs.signature.save(this.mime).split("base64,")[1],
			};
		},
		beginStroke(event) {
			if (!this.markMade) {
				this.clear(false);
			}
			this.eventTime = event.timeStamp / 1000;
		},
		endStroke(event) {
			this.strokes.push((event.timeStamp / 1000) - this.eventTime);
			this.emitChange();
		},
		hasMadeMark() {
			return this.markMade;
		},
		hasReachedStrokeLength() {
			return this.strokeDurationReached;
		},
		emitChange() {
			this.$emit("change", {
				hasMadeMark: this.markMade,
				hasReachedStrokeLength: this.strokeDurationReached,
				signature: this.getSignature(),
			});
		},
	},

	mounted() {
		this.width = this.fixedWidth || this.$el.getBoundingClientRect().width;
		this.height = this.width * this.heightRatio;
	},
};
</script>
